(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("lodash.clonedeep"), require("@popperjs/core"));
	else if(typeof define === 'function' && define.amd)
		define(["lodash.clonedeep", "@popperjs/core"], factory);
	else if(typeof exports === 'object')
		exports["DatePicker"] = factory(require("lodash.clonedeep"), require("@popperjs/core"));
	else
		root["DatePicker"] = factory(root["lodash.clonedeep"], root["@popperjs/core"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__201f__, __WEBPACK_EXTERNAL_MODULE_a5c7__) {
return 